module.exports = __webpack_public_path__ + "static/img/board2-EN.7ca50ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/Christmas2020/board2-EN.png
// module id = 4iT0
// module chunks = 1